const useUploadProps = {
	allowsAttachments: {
		type: Boolean,
		default: false,
		description: 'True means file uploads are allowed. Valid uploader options are also required.',
	},
	allowsInlineImages: {
		type: Boolean,
		default: false,
		description: 'True means inline image uploads are allowed. Valid uploader options are also required.',
	},
	uploaderObject: {
		type: Object,
		default: () => {},
	},
	uploaderOptions: {
		type: Object,
		default: () => {},
	},
};

export { useUploadProps };
